export default __webpack_public_path__ + "static/media/Group_1917.bca75628.png";